import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const setAllocateConstructionReports = async (sustainability_quantity: any) => {
  const token = getToken();
  let valid = false;
  let result;
  const params = {
    customer_reports_basis: sustainability_quantity,
  };

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/set_construction_reports_allocation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(params),
        }
      );

      result = await response.json();
      valid = result && result.success;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors) {
      return {
        valid: false,
        message: result.errors,
      };
    }
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
  };
};

export default setAllocateConstructionReports;
